module.exports = __webpack_public_path__ + "ac7c2f95d6a217820fe1aaa2a52d5a21.png";